import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const ExteriorFinish = ({ value, onChange, label = 'Exterior Finish:', disabled = false }) => {
    const defaultValue = value || 'White';
    const [selectedExteriorFinish, setSelectedExteriorFinish] = useState(defaultValue);

    // Call onChange once on mount if value is not provided
    useEffect(() => {
        if (!value) {
            onChange(defaultValue);
        }
    }, []); // empty deps to run only once
    
    const handleExteriorFinishChange = (e) => {
        setSelectedExteriorFinish(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} disabled={disabled} htmlFor="ExteriorFinish">{label}</label>
            <select style={{ display: "none" }}
                disabled={disabled}
                id="ExteriorFinish"
                value={selectedExteriorFinish}
                onChange={handleExteriorFinishChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedExteriorFinish === "White" ? "White ✔" : "White"}</option>
                <option value="Gentek">{selectedExteriorFinish === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default ExteriorFinish;
